import { Button } from "@fluentui/react-components";
import { DocumentTableRegular } from "@fluentui/react-icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePaymentPageStore } from "store/PaymentPageStore";
import { ExportExcelHandle } from "../ExportExcel";

type Props = {
  refExcelExport: ExportExcelHandle | undefined;
};

export const ExportExcelButton = ({ refExcelExport }: Props) => {
  const { t } = useTranslation();
  const [{ paymentsLoadStatus }] = usePaymentPageStore();

  return (
    <Button
      data-help="payments-export-excel"
      appearance="subtle"
      icon={<DocumentTableRegular fontSize={24} />}
      disabled={paymentsLoadStatus === "loading"}
      onClick={() => {
        refExcelExport?.save();
      }}
    >
      {t("greco.exportExcel")}
    </Button>
  );
};
